<template>
  <div>{{ getValue() }}</div>
</template>
<script>
export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    getValue() {
      const cell = this.cellData?.data ? this.cellData.data : this.cellData;
      let retVal = 'No text available';
      if (cell && cell.text) {
        if (cell.text.indexOf('^') >= 0) {
          retVal = cell.text.substring(cell.text.indexOf('^') + 1);
        } else {
          retVal = cell.text;
        }
      }
      return retVal;
    }
  }

};
</script>
<style>

</style>
